const pillGroupSchema = [
  {
    type: 'string',
    label: 'Filled Chip',
    name: 'filledChipText',
    description: 'Text for the filled chip.',
  },
  {
    type: 'string',
    label: 'Clear Chip',
    name: 'clearChipText',
    description: 'Text for the clear chip.',
  },
];

export default pillGroupSchema;
